import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuditLog, AuditLogs } from "../../api/observeApi";
import { getAuditLogs } from "./auditLogThunks";
import { LoadingStatus } from "../../common/types";

export interface AuditLogState {
  logs: AuditLog[];
  totalLogs: number;
  offset: number;
  resultsPerPage: number;
  status: LoadingStatus;
  summaryStatus: LoadingStatus;
  filters: string;
  query: string;
  timeInterval: number;
  currentTime: number;
}

const initialState: AuditLogState = {
  logs: [],
  totalLogs: 0,
  offset: 0,
  resultsPerPage: 100,
  status: "idle",
  summaryStatus: "idle",
  filters: "",
  query: "",
  timeInterval: 60 * 60, // One hour,
  currentTime: Date.now() * 1000000, // in nanoseconds
};

export const auditLogSlice = createSlice({
  name: "auditLog",
  initialState,
  reducers: {
    setOffset: (state, action: PayloadAction<number>) => {
      state.offset = action.payload;
    },
    resetLogs: (state) => {
      state.logs = [];
      state.currentTime = Date.now() * 1000000;
    },
    setFilter: (state, action: PayloadAction<string>) => {
      state.logs = [];
      state.currentTime = Date.now() * 1000000;
      state.filters = action.payload;
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.logs = [];
      state.currentTime = Date.now() * 1000000;
      state.query = action.payload;
    },
    setTimeInterval: (state, action: PayloadAction<number>) => {
      state.timeInterval = action.payload;
    },
    resetAuditLogState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuditLogs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAuditLogs.fulfilled, (state, action) => {
        state.status = "idle";
        const resp = action.payload as AuditLogs;
        if (resp.results) {
          state.logs.push(...resp.results);
        }
        if (resp.last_row_time) {
          state.currentTime = resp.last_row_time;
        }
        state.totalLogs = 1000000;
        if (!resp.results || resp.results?.length === 0) {
          state.totalLogs = state.logs.length;
        }
      })
      .addCase(getAuditLogs.rejected, (state, action) => {
        state.status = "failed";
        console.log("failed", action);
      });
    // .addCase(fetchAuditLogSummary.pending, (state) => {
    //   state.summaryStatus = "loading";
    // })
    // .addCase(fetchAuditLogSummary.fulfilled, (state, action) => {
    //   state.summaryStatus = "idle";
    //   if (action.payload) {
    //     state.summary = action.payload;
    //   }
    // })
    // .addCase(fetchAuditLogSummary.rejected, (state, action) => {
    //   state.summaryStatus = "failed";
    //   console.log("failed", action);
    // });
  },
});

export const {
  setOffset,
  resetLogs,
  resetAuditLogState,
  setFilter,
  setQuery,
  setTimeInterval,
} = auditLogSlice.actions;

export default auditLogSlice.reducer;
